import { render, staticRenderFns } from "./limitVisitorsIP.vue?vue&type=template&id=55aa12e6"
import script from "./limitVisitorsIP.vue?vue&type=script&lang=js"
export * from "./limitVisitorsIP.vue?vue&type=script&lang=js"
import style0 from "./limitVisitorsIP.vue?vue&type=style&index=0&id=55aa12e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports